<template>
	<div class="mt-4">
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-row>
			<!-- Left column for status summary -->
			<b-col md="4" class="mt-4">
				<!----<h2 class="text-center mb-4">Status Summary</h2>---->
				<div v-for="(status, index) in trackingStatus" :key="index" @click="selectStatus(status)"
					class="status-summary" :class="{ 'selected': selectedStatus.value === status.value }">
					<b-card  text-variant="black" class="mb-2">

						<b-overlay :show="status.loading" no-wrap></b-overlay>
						<div class="status-summary-item">
							<div class="status-color" :style="{ backgroundColor: status.color }"></div>
							<div class="status-details">
								<h5>{{ status.name }}</h5>
								<p>{{ status.totalRides }} Rides</p>
							</div>
						</div>
					</b-card>
				</div>
			</b-col>
			<!-- Right column for displaying rides -->
			<b-col md="8" class="mt-2">
				<!----<h2 class="text-center mb-4">Rides</h2>---->
				<b-card v-if="selectedStatus" style="" >
					<b-overlay :show="selectedStatus.loading" no-wrap></b-overlay>
					<h4 class="text-center mt-2">{{ selectedStatus.name }}</h4>
                    <b-pagination 
                        v-if="currentRides.length > 0"
                        :total-rows="selectedStatus.totalRides" 
                        v-model="pag.currentPage"
                        :per-page="pag.perPage" 
                        align="right"
                        class="mt-3"
                        @input="nextPage"

                    ></b-pagination>
                    
					<div v-if="currentRides.length > 0" class="ride-list">
						<b-card v-for="(ride, index) in selectedStatus.rides" :key="index" class="mb-2 p-2" :class="{ 'striped': index % 2 !== 0 }">
							<b-row>
								<b-col class="col-12 col-md-6">
									<p class="text-secondary">
										<b-badge  variant="default" v-if="ride.reservation.operatedBy === 'sc'"> <ScIcon /> {{$t('bookings.shuttleCentralService')}}</b-badge>
										<b-badge  variant="default" v-else><md-icon icon="home" /> <strong>{{$t('bookings.selfService')}}</strong></b-badge>
									</p>
								</b-col>
								<b-col class="col-12 col-md-6">
									<p class="text-right mr-3 mb-2 text-primary"><md-icon :icon="tripIcon(ride)"/>
										<a href="#" @click="openReservation(ride)" class="text-primary">{{ ride.serviceNumber }}</a>
                                        <span v-if="!$root.isEmpty(ride.internalReference)">| {{ ride.internalReference }}</span>
										| <b-badge :variant="getVariantBystatus(ride.status)">{{ $t("bookings.serviceStatusOpts."+ride.status) }}</b-badge>
                                       
									</p>
								</b-col>
							</b-row>
                            <!-- Driver and Vehicle Info -->
                            <b-row class="mt-2 align-items-center">
                                <b-col class="col-12 col-md-6">
                                    <p class="mb-0">
                                        <b>{{ $t("bookings.driver") }}:</b>
                                        <a href="#" @click.prevent="openDriverModal(ride)" class="text-info" v-b-tooltip.hover :title="$t('assignation.assignChange')">
                                            {{ getDriverFromRide(ride)}}
                                        </a>
										<b-badge 
											variant="primary" 
											v-b-tooltip.hover title="Tarjeta de Identificación Aeroportuaria"
											v-if="hasDriver(ride) && ride.userDriver.tia == true">
											TIA
										</b-badge>
                                    </p>
                                </b-col>
                                <b-col class="col-12 col-md-6">
                                    <p class="mb-0">
                                        <b class="text-sm">{{ $t("bookings.transportUnit") }}:</b> <small>{{ getUnitFromRide(ride) }}</small> 
                                    </p>
                                </b-col>
                            </b-row>

							<p><b>{{ $t("bookings.clientName") }}:</b> {{ ride.reservation.client.firstName }}  {{ ride.reservation.client.lastName }}</p>
							<p><b>{{ $t("bookings.pickupDatetime") }}:</b> {{ ride.pickupDatetime }} Hrs.</p>
                            <b-row>
                                <b-col class="col-12 col-md-6">
                                    <p><b>{{ $t("bookings.pickup") }}:</b> {{ ride.pickup.name }}</p>
                                </b-col>
                                <b-col class="col-12 col-md-6">
                                    <p><b>{{ $t("bookings.dropoff") }}:</b> {{ ride.dropoff.name }}</p>
                                </b-col>
                            </b-row>
						</b-card>
					</div>
					<div v-else>
						<p class="text-center">{{ $t("global.ajaxTable.noRecordsFound") }}</p>
					</div>
				</b-card>
				<b-card v-else>
					<p class="text-center">{{ $t("global.selectOption") }}.</p>
				</b-card>
			</b-col>
		</b-row>
		<ResSingle
			ref="single"
			:model-id.sync="reservation.id"
			:show.sync="reservation.show"
			operated-by="supplier"
		/>
        <b-sidebar sidebar-class="sidebar-assignation" :title="$t('assignation.operation')" bg-variant="light" shadow right v-model="showDriverAssignment">
            <DriverAssignmentModule :ridesSelected="ridesSelected" @onUpdate="refreshCurrentList()" />
        </b-sidebar>
	</div>
</template>

<script>
import ResSingle from '../Single.vue';
import DriverAssignmentModule from './../../assignation/DriverAssignment.vue';
export default {
	props:{
		filters:{
			type : Object,
			required: true
		}
	},
	components:{ResSingle,DriverAssignmentModule},
	data() {
		return {
			loading:false,
			reservation:{
				id:-1,
				show:false
			},
			statuses:[
				{value:'pending',name:this.$t('bookings.trackingStatusOpts.pending'),rides:[],color: 'outline-primary',loading:false,totalRides:0},
				{value:'onWayToPickup',name:this.$t('bookings.trackingStatusOpts.onWayToPickup'),rides:[],color: 'primary',loading:false,totalRides:0},
				{value:'atPickup',name:this.$t('bookings.trackingStatusOpts.atPickup'),rides:[],color: 'primary',loading:false,totalRides:0},
				{value:'onWayToDropoff',name:this.$t('bookings.trackingStatusOpts.onWayToDropoff'),rides:[],color: 'primary',loading:false,totalRides:0},
				{value:'finished',name:this.$t('bookings.trackingStatusOpts.finished'),rides:[],color: 'primary',loading:false,totalRides:0},
				{value:'noShow',name:this.$t('bookings.trackingStatusOpts.noShow'),rides:[],color: 'primary',loading:false,totalRides:0},
			],
			selectedStatus: {value:"",rides:[]},
			rides:[],
            pag:{
                currentPage:1,
                perPage:20
            },
            showDriverAssignment:false,
            ridesSelected:[],
		};
	},
	async created() {
		this.loading = true;
		for (let i = this.statuses.length - 1; i >= 0; i--) {
			try {
				await this.selectStatus(this.statuses[i]); // Call selectStatus for each status
			} catch (error) {
				console.error('Error processing status:', error);
			}
		}
		this.loading= false;
		//await this.selectStatus(this.statuses[0])
	},
	computed:{
		trackingStatus(){
			return this.statuses;
		},
        offset(){
            let offset = this.pag.perPage * (this.pag.currentPage - 1 );
            return offset;
        },
        currentRides(){
            if(this.$root.isEmpty(this.selectedStatus.rides)) return [];
            return this.selectedStatus.rides;
        },

	},
	methods: {
        openDriverModal(ride){
            this.ridesSelected = [ride.id]
            this.showDriverAssignment = !this.showDriverAssignment;

        },
        async refresh(){
            this.loading = true;
            for (let i = this.statuses.length - 1; i >= 0; i--) {
                try {
                    await this.selectStatus(this.statuses[i]); // Call selectStatus for each status
                } catch (error) {
                    console.error('Error processing status:', error);
                }
            }
            this.loading= false;
        },
		getVariantBystatus(status){
			try{
				let variant = this.$root.auxVars.transportServiceStatusOpts.find((el)=>{
					return el.value==status
				});
				if(variant) return variant.class;
			}catch(err){console.log(err)}
			return "info";
		},
		tripIcon(rideModel) {
			if (rideModel.pickup.isAirport) return "flight_land";
			//A2H
			else if (rideModel.dropoff.isAirport) return "flight_takeoff";
			//H2A
			else return "place"; //P2P
		},
		openReservation(rideModel){
			this.reservation.id =rideModel.reservationId,
			this.reservation.show=true;
		},
		generateRides(count) {
			const rides = [];
			for (let i = 0; i < count; i++) {
				rides.push({ name: `Ride ${i + 1}`, destination: `Destination ${i + 1}`, passenger: `Passenger ${i + 1}` });
			}
			return rides;
		},
		async getRides(status){
			try{
                let _filters = {...this.filters,...{trackingStatus:status}}
                let params={
                    filters:_filters,
                    limit:this.pag.perPage,
                    offset:this.offset,
                    sortBy:"pickupDatetime",
                    sortOrder:'ASC'
                }
                const response = await this.$root.api
                .get(`/transport-services`,{params:params})
                return response.data;
            }catch(error){
                this.$root.showAlert("Error fetching rides with status: "+status,{variant:'danger'});
                return []; // Return an empty array in case of error
            }
		},
		async selectStatus(status,isPagination=false) {
            if(!isPagination){
                this.pag.currentPage=1
            }
            this.selectedStatus = status;
            status.loading = true;
            let ridesResponse = await this.getRides(status.value);
            status.rides = ridesResponse.rows;
            status.totalRides = ridesResponse.totalRows??0;
            status.loading = false;
           
		},
        refreshCurrentList(){
            this.selectStatus(this.selectedStatus,true)
        },
        nextPage(newPage){
            this.pag.currentPage = newPage;
            this.selectStatus(this.selectedStatus,true)
        },
        getDriverFromRide(ride){
            if(this.$root.isEmpty(ride.userDriver)) return this.$t('bookings.assign');
            return ride.userDriver.firstName+" "+ride.userDriver.lastName
        },
		hasDriver(ride) {
            if (!this.$root.isEmpty(ride.userDriver)) return true
            return false;
        },
        getUnitFromRide(ride){
            if(this.$root.isEmpty(ride.transportUnit)) return '--';
            return ride.transportUnit.title;
        },  
        async updateTotalsByStatus(){
            for (let i = this.statuses.length - 1; i >= 0; i--) {
                try {
                    let ridesResponse   = await this.getRides(this.statuses[i].value); // Call selectStatus for each status
                    this.statuses[i].totalRides = ridesResponse.totalRows??'--';
                } catch (error) {
                    console.error('Error processing status:', error);
                }
            }
        }
	}
};
</script>

<style scoped>
.status-summary {
	cursor: pointer;
}
.status-summary.selected .card {
	background-color: blue;
	color: white;
}

.status-summary-item {
	display: flex;
	align-items: center;
}

.status-summary-item.selected {
	background-color: rgba(0, 0, 0, 0.1) !important;
}

.status-color {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	margin-right: 10px;
}

.status-details {
	flex: 1;
}

.card-body{
	padding: 5px !important;
}
p{
	margin: 0.5px;
    font-size: 14px;
}
.card{
	border-radius: .5rem !important;
}
.striped{
	background-color: #f4f8fc;
}
.ride-list{
	padding: 10px;
    background: #f7f7f7;
	border-radius: 1rem;
}

@media (max-width: 600px){
    .ride-list{
        padding: unset;
    }
}
</style>
